import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { cpf, cnpj } from "cpf-cnpj-validator";
import Api from "../../Api";
import ClientsForm from "./Form";
import Section from "../../parts/Section";
import { Client, UIValue } from "../../types";

const ClientsUpdate = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [client, setClient] = useState<Client | null>(null);
  const [error, setError] = useState(false);
  const [errorDoc, setErrorDoc] = useState(false);

  const changeClient = (key: string) => (value: UIValue) => {
    setClient((client) => ({ ...client!, [key]: value }));
  };

  useEffect(() => {
    Api.clientsGetByUuid(uuid!).then(setClient);
  }, [uuid]);

  const save = async () => {
    setError(false);
    setErrorDoc(false);

    const validateDocument = client!.type === "pf" ? cpf.isValid : cnpj.isValid;
    if (!validateDocument(client!.document)) {
      setErrorDoc(true);
      return;
    }

    const result = await Api.clientsUpdate(uuid!, client!);
    result.success ? navigate("/clientes") : setError(true);
  };

  return (
    <Section className="p-4 pb-32">
      {!!client && (
        <ClientsForm
          client={client}
          buttonText={"Salvar"}
          onSubmit={save}
          onChange={changeClient}
          error={error}
          errorDoc={errorDoc}
        />
      )}
    </Section>
  );
};

export default ClientsUpdate;
